import { Product } from "@/types";
import { SerpElement } from "@nosto/search-js/preact/serp";
import DynamicCard from "@/elements/DynamicCard/DynamicCard";
import { SearchTrackOptions } from "@nosto/nosto-js/client";

export default function DynamicCardProduct({
  product,
  index,
  searchTrackType,
}: {
  product: Product;
  index: number;
  searchTrackType: SearchTrackOptions | null;
}) {
  return (
    <SerpElement
      as={DynamicCard}
      hit={{
        productId: product.productId!,
        url: product.url,
      }}
      componentProps={
        {
          handle: product.handle!,
          section: "nosto-product-tile",
          index: index,
          itemType: searchTrackType,
        } as any
      }
    />
  );
}
